<template>
	<div
		v-if="appStore.isLoading"
		class="fixed bg-gray-50 h-screen w-screen inset-x-0 inset-y-0 flex items-center justify-center z-40">
		<img width="150" src="@/assets/image/launchpad.png" class="animate-pulse" alt="Launchpad" />
	</div>
</template>

<script lang="ts" setup>
	import useAppStore from '@/stores/app'
	const appStore = useAppStore()
</script>
